import React from "react";

// Navigate
import { useNavigate, useParams } from "react-router-dom";

// Mui
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid2";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";

// Mui Styles
import _ from "lodash";
import { StyledPaper } from "../styles/mui/globalStyles";

// Mui Icon
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import SaveIcon from "@mui/icons-material/Save";
import IconButton from "@mui/material/IconButton";

// Components
import Layout from "../components/layout";
import Title from "../components/title";

// Fetch
import {
  getAccessControlByUser,
  getControlCategory,
  resetAccessControlUser,
  updateAccessControlUser,
} from "../fetch/fetchType";

const StaffManagePermissionPage = (props) => {
  const { open, setOpen } = props;

  const { id } = useParams();

  // Navigate
  const navigate = useNavigate();

  //Ref
  const fetchOffRef = React.useRef(null);

  // States
  const [editCount, setEditCount] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState(false);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [accessControl, setAccessControl] = React.useState({
    accessControlUser: [],
    accessControl: [],
    category: [],
  });
  const [rowsData, setRowsData] = React.useState([]);

  const handleOnClickReset = async () => {
    const data = await resetAccessControlUser(id);
    if (data && data.results) {
      setSnackMessage(`重設成功`);
      setEditCount((prev) => (prev = 0));
    } else if (data && !data.results) {
      setSnackMessage(`請先儲存`);
    } else {
      setSnackMessage(`重設失敗`);
    }
    setSnackOpen(true);
    setTimeout(() => {
      setSnackOpen(false);
    }, 1500);
    fetchAll();
  };

  const handleOnClickSave = async () => {
    const isActive = accessControl.accessControlUser.filter(
      (item) => item.user_id === parseInt(id) && item.is_active === false
    );
    if (isActive.length === accessControl.category.length) {
      const data = await resetAccessControlUser(id);
      if (data) {
        setSnackMessage(`修改失敗，已重設`);
        fetchAll();
      }
    } else {
      await updateAccessControlUser(accessControl.accessControlUser).then(
        (data) => {
          if (data && data.results) {
            setSnackMessage(`修改成功`);
            setEditCount((prev) => (prev = 0));
            setAccessControl((prev) => ({ ...prev, accessControl: [] }));
          } else {
            setSnackMessage(`修改失敗`);
          }
        }
      );
    }
    setSnackOpen(true);
    setTimeout(() => {
      setSnackOpen(false);
    }, 1500);
  };
  const handleActionsClick = (e, control_id, action) => {
    const accessControlUser = [...accessControl.accessControlUser];
    const selectedPremissionIndex = accessControlUser.findIndex(
      (p) => p.control_id === control_id
    );
    if (!accessControlUser[selectedPremissionIndex]) {
      accessControlUser.push({
        actions: {
          [action]: e.target.checked,
        },
        control_id,
        is_active: true,
        is_lock: false,
        user_id: parseInt(id),
        id: generateMaxId(),
      });
    } else {
      accessControlUser[selectedPremissionIndex].actions = {
        ...accessControlUser[selectedPremissionIndex].actions,
        [action]: e.target.checked,
      };
    }
    setEditCount((prev) => prev + 1);
    setAccessControl((prev) => ({
      ...prev,
      accessControlUser: accessControlUser,
    }));
  };
  const handlePermissionClick = (targetObjectUser, categoryItem) => {
    const copyAccessControlUser = [...accessControl.accessControlUser];

    if (!targetObjectUser) {
      const newObject = {
        id: generateMaxId(),
        user_id: parseInt(id),
        control_id: categoryItem.id,
        is_active: true,
        actions: {},
      };
      setAccessControl((prev) => ({
        ...prev,
        accessControlUser: [...prev.accessControlUser, newObject],
      }));
    } else {
      const index = accessControl.accessControlUser.findIndex(
        (findItem) =>
          findItem.user_id === parseInt(id) &&
          findItem.control_id === categoryItem.id
      );

      if (index > -1) {
        const copyTargetObjectUser = {
          ...targetObjectUser,
          is_active: !targetObjectUser.is_active,
          actions:
            !targetObjectUser.is_active === true
              ? targetObjectUser.actions
              : {},
        };
        copyAccessControlUser[index] = copyTargetObjectUser;
        setAccessControl((prev) => ({
          ...prev,
          accessControlUser: copyAccessControlUser,
        }));
      }
    }

    setEditCount((prev) => prev + 1);
  };
  // Fetch all
  const fetchAll = async () => {
    await getAccessControlByUser(id).then((data) => {
      if (data && data.results) {
        setAccessControl((prev) => ({
          ...prev,
          accessControlUser: [...data.data.accessControlUser],
          accessControl: [...data.data.accessControl],
        }));
      }
    });
    const { data: controlCategory } = await getControlCategory();
    const parent = _.filter(controlCategory, (c) => c.parent_id === 0);
    const category = _.map(parent, (p) => {
      return {
        ...p,
        child: _.filter(controlCategory, (c) => c.parent_id === p.id),
      };
    });
    const orderedCategory = [];
    _.forEach(category, (c) => {
      orderedCategory.push(c);
      _.forEach(c.child, (child) => {
        orderedCategory.push(child);
      });
    });
    setAccessControl((prev) => ({
      ...prev,
      category: [...orderedCategory],
    }));

    fetchOffRef.current = true;
  };
  const generateMaxId = () => {
    const maxIdObject = accessControl.accessControlUser.reduce(
      (prev, cur) => (cur.id > prev.id ? cur : prev),
      {
        id: 0,
        user_id: "",
        control: "",
        is_active: false,
      }
    );
    return maxIdObject.id + 1;
  };
  const overrideAccessControl = () => {
    let copyAccessControlUser = [...accessControl.accessControlUser];
    const generateMaxId = () => {
      const maxIdObject = copyAccessControlUser.reduce(
        (prev, cur) => (cur.id > prev.id ? cur : prev),
        {
          id: 0,
          user_id: "",
          control: "",
          is_active: false,
        }
      );
      return maxIdObject.id + 1;
    };

    accessControl.accessControl.forEach((item) => {
      const targetObject = accessControl.accessControlUser.find(
        (obj) => obj.user_id === id && obj.control_id === item.control_id
      );

      const targetCopy = copyAccessControlUser.find(
        (obj) =>
          obj.user_id === parseInt(id) && obj.control_id === item.control_id
      );

      if (!targetObject && !targetCopy) {
        delete item["role_id"];
        copyAccessControlUser = [
          ...copyAccessControlUser,
          {
            ...item,
            id: generateMaxId(),
            user_id: parseInt(id),
          },
        ];
      }
    });

    setAccessControl((prev) => ({
      ...prev,
      accessControlUser: copyAccessControlUser,
    }));
    fetchOffRef.current = false;
  };

  React.useEffect(() => {
    if (fetchOffRef.current === null) {
      fetchAll();
    }
    if (fetchOffRef.current && accessControl.accessControl.length > 0) {
      overrideAccessControl();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessControl]);

  return (
    <Layout
      header="StaffManageDetailPage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      selectedIndex={5}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title={`管理員工 / ${id ? "修改員工" : "新增員工"} / 權限設置`}
        history={() => navigate(-1)}
        children={
          <div>
            {/* Reset Record */}
            <IconButton
              component="label"
              color={"primary"}
              onClick={handleOnClickReset}
            >
              <RestartAltIcon />
            </IconButton>
            {/* Save Record */}
            <IconButton
              component="label"
              disabled={
                accessControl.accessControl.length === 0
                  ? editCount <= 0
                    ? true
                    : false
                  : accessControl.accessControl.length === 0 &&
                    accessControl.accessControlUser.length > 0
                  ? true
                  : false
              }
              color={"primary"}
              onClick={handleOnClickSave}
            >
              <SaveIcon />
            </IconButton>
          </div>
        }
      />

      <StyledPaper page={"yes"}>
        {/* </ThemeProvider> */}
        <Grid container spacing={2}>
          <TableContainer>
            <Table>
              <TableHead></TableHead>
              {accessControl.category.length > 0 ? (
                <TableBody>
                  {accessControl.category.map((categoryItem, index) => {
                    const targetObjectUser =
                      accessControl.accessControlUser.find((findItem) => {
                        return findItem.control_id === categoryItem.id;
                      });
                    return (
                      <React.Fragment>
                        <TableRow key={index}>
                          <TableCell
                            align="left"
                            sx={{
                              fontWeight:
                                categoryItem.parent_id === 0
                                  ? "bold"
                                  : "normal",
                            }}
                          >
                            {categoryItem.parent_id !== 0 ? " - " : ""}
                            {categoryItem.category}
                          </TableCell>
                          <TableCell key={index} align="left">
                            <Checkbox
                              disableRipple={targetObjectUser?.is_lock}
                              color="success"
                              checked={
                                targetObjectUser
                                  ? targetObjectUser.is_active === true
                                    ? true
                                    : false
                                  : false
                              }
                              onChange={() =>
                                handlePermissionClick(
                                  targetObjectUser,
                                  categoryItem
                                )
                              }
                              inputProps={{ "aria-label": "controlled" }}
                            />
                          </TableCell>
                        </TableRow>
                        {_.map(categoryItem?.actions, (action, key) => {
                          const targetObject =
                            accessControl.accessControlUser.find(
                              (findItem) =>
                                findItem.control_id === categoryItem.id
                            );
                          let is_checked = false;
                          if (targetObject?.actions) {
                            is_checked = targetObject.actions[key];
                          }
                          return (
                            <TableRow key={key}>
                              <TableCell>
                                <Typography
                                  variant="inherit"
                                  component="div"
                                  sx={{ fontStyle: "italic", ml: 3 }}
                                >
                                  *{action}
                                </Typography>
                              </TableCell>
                              <TableCell key={index} align="left">
                                <Checkbox
                                  onChange={(e) =>
                                    handleActionsClick(e, categoryItem.id, key)
                                  }
                                  color="success"
                                  checked={is_checked}
                                  inputProps={{
                                    "aria-label": "controlled",
                                  }}
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </React.Fragment>
                    );
                  })}
                </TableBody>
              ) : rowsData.length <= 0 && isLoading === false ? (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      沒有資料
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      <CircularProgress size={24} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Grid>
      </StyledPaper>
    </Layout>
  );
};

export default StaffManagePermissionPage;
